<div class="story">
  <ng-container *ngIf="thumbnailUrl">
    <img class="colour-fetch" [src]="thumbnailUrl"/>
    <img [src]="thumbnailUrl"/>
  </ng-container>
  <h4>{{story.name}}</h4>
  <div class="description">{{story.tagline}}</div>
</div>
